import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { WorkflowComponent } from 'src/workflow/workflow.component';

import { AuthGuardService } from './modules/main/service/authguard.service';
import { PageNotFoundComponent } from './page/error/404/404.component';

import { GenericErrorComponent } from './page/generic_error/generic_error.component';
import { AdminLoginComponent } from './page/admin-login/admin-login.component';
import { AdminLogoutComponent } from './page/admin-logout/admin-logout.component';

import { RedirectComponent } from './page/redirect/redirect.component';
import { OrigenceLegalComponent } from 'src/origence-legal/origence-legal.component';
import { UserVerificationErrorComponent } from './page/user-verification-error/user-verification-error.component';
import { DXLogoutComponent } from './page/dx-logout/dx-logout.component';

/** App Routing config */
const AppRouting: Routes = [
  { path: 'mortgage', redirectTo: '/error/404', pathMatch: 'full' },
  { path: 'autoloans', redirectTo: '/error/404', pathMatch: 'full' },
  { path: 'creditcards', redirectTo: '/error/404', pathMatch: 'full' },
  { path: 'tools', redirectTo: '/error/404', pathMatch: 'full' },
  // Dummy component for OAO
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'user/login'
  },
  {
    component: AdminLoginComponent,
    path: 'admin/login'
  },
  {
    component: AdminLogoutComponent,
    path: 'admin/logout'
  },
  {
    component: DXLogoutComponent,
    path: 'user/logout'
  },
  {
    loadChildren: () => import('../admin/admin.module').then((m) => m.AdminModule),
    path: 'admin'
  },
  {
    component: RedirectComponent,
    path: 'redirect'
  },
  {
    loadChildren: () => import('../integration/integration.master.module').then((m) => m.IntegrationModule),
    path: 'integration'
  },
  // Dynamic Workflow Widget Route (prefix)
  {
    path: 'app',
    component: WorkflowComponent,
    children: []
  },
  // Dynamic Workflow Widget Redirects
  {
    path: 'heloc',
    pathMatch: 'prefix',
    redirectTo: 'app/heloc'
  },
  {
    path: 'ola',
    pathMatch: 'prefix',
    redirectTo: 'app/ola'
  },
  {
    path: 'ola-consumer',
    pathMatch: 'prefix',
    redirectTo: 'app/ola-consumer'
  },
  // {
  //   canActivate: [PathGuardService, AuthenticateGuard],
  //   loadChildren: () => import('../oao-postapp/oao-postapp.module').then((m) => m.OaoPostappModule),
  //   path: 'oao/postapp'
  // },
  {
    // canActivate: [PathGuardService, AuthenticateGuard],
    loadChildren: () => import('../postapp/postapp.module').then((m) => m.PostappModule),
    path: 'postapp'
  },
  {
    path: 'oao',
    pathMatch: 'prefix',
    redirectTo: 'app/oao'
  },
  {
    path: 'mortgage',
    pathMatch: 'prefix',
    redirectTo: 'app/mortgage'
  },
  {
    canActivate: [AuthGuardService],
    loadChildren: () => import('./modules/main/main.module').then((m) => m.MainModule),
    path: 'consumer'
  },
  {
    loadChildren: () => import('../user/user.module').then((m) => m.UserModule),
    path: 'user'
  },
  {
    loadChildren: () => import('../legal/legal.module').then((m) => m.LegalModule),
    path: 'legal'
  },
  {
    path: 'terms-and-policy',
    component: OrigenceLegalComponent
  },
  {
    children: [
      {
        component: PageNotFoundComponent,
        path: '404'
      }
    ],
    path: 'error'
  },
  {
    path: 'oops',
    component: GenericErrorComponent
  },
  {
    path: 'contact-us',
    component: UserVerificationErrorComponent
  },
  {
    path: '**',
    pathMatch: 'full',
    redirectTo: '/error/404'
  },
  { path: '**', pathMatch: 'full', redirectTo: '/oops' }
];

@NgModule({
  imports: [
    RouterModule.forRoot(AppRouting, {
      onSameUrlNavigation: 'reload',
      useHash: false
    })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
